module.exports = __webpack_public_path__ + "img/41.faff7e61.png";